'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var React = require('react');

var _excluded = ["initialState"];
function NOOP_TRANSFORM(oldState) {
  return oldState;
}
function index (defaultValue) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP_TRANSFORM;
  var defaultUpdate = function defaultUpdate() {
    return defaultValue;
  };
  var ctx = /*#__PURE__*/React.createContext({
    state: defaultValue,
    update: defaultUpdate
  });
  var Provider = function Provider(_ref) {
    var initialState = _ref.initialState,
      props = _objectWithoutProperties(_ref, _excluded);
    var _React$useState = React.useState(transform(initialState || defaultValue)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];
    var update = React.useCallback(function (setStateAction) {
      setState(function (prevState) {
        var newState = typeof setStateAction === 'function' ? setStateAction(prevState) : setStateAction;
        return transform(newState);
      });
    }, [setState]);
    var value = React.useMemo(function () {
      return {
        state: state,
        update: update
      };
    }, [state, update]);
    return /*#__PURE__*/React.createElement(ctx.Provider, _extends({
      value: value
    }, props));
  };
  return [ctx, Provider];
}

exports.default = index;
